export default __webpack_public_path__ + "static/media/sliderImage-2.db96df5f.jpg";